import React, {Component} from 'react';
import {isEmpty, takeWhile} from 'lodash';
import {connect} from "react-redux";

import * as AuthAction from "../../actions/AuthAction";
import * as StaffDashboardAction from '../../actions/StaffDashboardAction';
import {bindActionCreators} from "redux";

import {toast} from 'react-toastify';
import ReactTooltip from 'react-tooltip';


import {Link} from "react-router-dom";
import logo from "../../public/assets/images/symphony_logo_large_1.png";
import logoMini from "../../public/assets/images/small_logo_new_3.png";
import {downloadPDF} from "../common/Constants";
import {getUser} from "../../utils/TokenManager";
import JobDescriptionService from "../../services/JobDescriptionService";
import StaffDashboardService from "../../services/StaffDasboardService";
import ErrorMsg from "../common/ErrorMsg";
import LoadingModal from "../common/LoadingModal";
import SupportModal from "../staffDashboard/SupportModal";
import EvaluationModal from "./PerformanceEvaluationModal";
import DestinationsModal from "./DestinationsModal";
import AuditForm from "./AuditForm";
import ArchivedAudits from "../complianceAudit/ArchivedAudits";
import PeriodSelectionModal from "../daliyAttendance/PeriodSelection";
import TrainingVideosModal from "./TrainingVideos";
import CommissionModal from "./CommissionReport";


 class SideNav extends Component {
    
    state = {
        isLoading: false,
        openSupportModal: false,
        openEvaluationModal: false,
        isOpenDestinations: false,
        isStaffRevenueOpen: false,
        openAuditForm: false,
        openAuditForm: false,
        openArchivedAudits: false,
        auditId: 0,
        isOpenReport: false,
        openTimeSheet: false,
        openPTO: false,
        openTrainingVideos: false,
        isOpenCommissionModal: false,
        showperformacereport: false,

    };

    componentDidUpdate = (prevProps) => {
        if (prevProps.fullSideBar && !this.props.fullSideBar) {
            this.closeAllMenu();
        }
    }

    closeAllMenu = () => {
        this.setState({
            isOpenReport: false
        });
        return false;
    }

    toggleReportMenu = () => {
        this.setState(prevState => ({
            isOpenReport: !prevState.isOpenReport,
        }));
        this.props.openSideBar();
        return false;
    }

    generatePDF = async (event, reportType, auditId='') => {
        try {
            let status = false, result = {};
            let userDetails = getUser();
            if (reportType === 1) {
                let compId = 0;
                if (this.props.staffDashboard.staffKPIList) {
                    compId = this.props.staffDashboard.staffKPIList.compensation_profile_id;
                }
                if (compId > 0) {
                    result = await StaffDashboardService.getAuditFormReport(compId, auditId);
                    if (200 === result.status) {
                        if (result.data.content) {
                            status = true;
                        } else {
                            status = false;
                            toast.error("Audit form is not available. Please contact admin.");
                        }
                    } else {
                        status = false;
                    }
                }
            } else if (reportType === 2) {
                this.setState({isLoading: true});
                result = await StaffDashboardService.getCompensationAgreementPDF();
                if (200 === result.status) {
                    status = true;
                } else {
                    status = false;
                }
                this.setState({isLoading: false});
            } else if (reportType === 3) {
                this.setState({isLoading: true});
                result = await JobDescriptionService.getDescriptionPDFContent(userDetails.job_title);
                if (200 === result.status) {
                    status = true;
                } else {
                    status = false;
                }
                this.setState({isLoading: false});
            } else if (reportType === 4) {
                this.setState({isLoading: true});
                result = await StaffDashboardService.getKPIExplanationPDF();
                if (200 === result.status) {
                    status = true;
                } else {
                    status = false;
                }
                this.setState({isLoading: false});
            } else if (reportType === 5) {
                this.setState({isLoading: true});
                result = await StaffDashboardService.getPerformanceEvaluationPDF();
                if (200 === result.status) {
                    status = true;
                } else {
                    status = false;
                }
                this.setState({isLoading: false});
            } else {
                this.setState({isLoading: true});
                result = await StaffDashboardService.getTimesheetPDF();
                if (200 === result.status) {
                    status = true;
                } else {
                    status = false;
                }
                this.setState({isLoading: false});
            }
            
            if (status && (!(isEmpty(result))) && (!(isEmpty(result.data)))) {
                let content = result.data.content;
                let fileName = result.data.file_name;
                downloadPDF(content, fileName);
            }
        } catch (error) {
            console.log(error);
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
    }

    getUserCompensation = async () => {
        try {
            let result = await StaffDashboardService.getStaffCompensationList();
            if (result) {
                let compensationProfileList = result.map(profile => ({...profile}));
                if (compensationProfileList > 0) {
                    this.setState({showperformacereport:true});
                }
            }            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

    openSupport = () => {
        this.setState({openSupportModal: true});
    }


    toggleSupportModal = () => {
        this.setState((prevState) => ({openSupportModal: !prevState.openSupportModal}));
    };

    openEvaluationModal = () => {
        this.setState({openEvaluationModal: true});
    }

    toggleEvaluationModal = () => {
        this.setState((prevState) => ({openEvaluationModal: !prevState.openEvaluationModal}));
    };

    openDestinationModal = () => {
        this.setState({isOpenDestinations: true});
    }

    toggleDestinationModal = () => {
        this.setState((prevState) => ({isOpenDestinations: !prevState.isOpenDestinations}));
    };

    openStaffRevenueModal = () => {
        this.setState({isStaffRevenueOpen: true});
    }

    toggleStaffSalesModal = () => {
        this.setState((prevState) => ({isStaffRevenueOpen: !prevState.isStaffRevenueOpen}));
    };

    openAuditFormModal = (auditId='') => {
        this.setState({openAuditForm: true, auditId});
    }

    toggleAuditFormModal = () => {
        this.setState((prevState) => ({openAuditForm: !prevState.openAuditForm}));
    };

    openArchivedAuditsModal = () => {
        this.setState({openArchivedAudits: true});
    }

    toggleArchivedAuditsModal = () => {
        this.setState((prevState) => ({openArchivedAudits: !prevState.openArchivedAudits}));
    };

    openTimeSheetModal = () => {
        console.log("staff name");
        console.log(this.props.staffname);
        this.setState({openTimeSheet: true});
    };

    toggleTimeSheetModal = () => {
        this.setState((prevState) => ({openTimeSheet: !prevState.openTimeSheet}));
    };

    openTrainingVideosModal = () => {
        this.setState({openTrainingVideos: true});
    };

    toggleTrainingVideosModal = () => {
        this.setState({openTrainingVideos: false});
    };

    openCommissionModal = () => {
        this.setState({isOpenCommissionModal: true});
    };

    closeCommissionModal = () => {
        this.setState({isOpenCommissionModal: false});
    };

    render = () => {
        const isAgencyMonitorVisble = getUser().agency_monitor;
        
        const {
            openSupportModal, openEvaluationModal, isOpenDestinations, isLoading,
            openAuditForm, auditId, openArchivedAudits, isOpenReport, openTimeSheet,
            openTrainingVideos, isOpenCommissionModal,
        } = this.state;

        const {showperformacereport} = this.props;

        const {fullSideBar} = this.props;
        let auditFormAvailability = false, KPIReportAvailability = false; 
        let agreementAvailability = false, jobDescriptionAvailability = false;
        let timeClock = false, destinationsAvailability = false;
        let commissionName = 'Commission', commissionReportAvailability = false;
        let compId = 0, compDates = '';

        if (this.props.staffDashboard.staffKPIList) {
            auditFormAvailability = this.props.staffDashboard.staffKPIList.audit_form_available; 
            KPIReportAvailability = this.props.staffDashboard.staffKPIList.kpi_report_available; 
            agreementAvailability = this.props.staffDashboard.staffKPIList.agreement_available; 
            commissionName = this.props.staffDashboard.staffKPIList.commission_name;
            commissionReportAvailability = this.props.staffDashboard.staffKPIList.commission_report_available;
            jobDescriptionAvailability = this.props.staffDashboard.staffKPIList.job_description_available; 
            timeClock = this.props.staffDashboard.staffKPIList.time_clock;
            destinationsAvailability = this.props.staffDashboard.staffKPIList.destinations_available;
            compId = this.props.staffDashboard.staffKPIList.compensation_profile_id;
            compDates = this.props.staffDashboard.staffKPIList.compensation_dates;
        }

        return (
            <aside className={`sidebar ${fullSideBar ? "full" : "mini"}`}>
                {isLoading && <LoadingModal modal={isLoading} />}
                <div className={`navbar-header ${fullSideBar ? "p-1" : "p-2"}`}>
                    <Link to="/home" title="Symphony Home">
                        {fullSideBar ? 
                            <span className="logo-text">
                                <img src={logo} alt="homepage"/>
                            </span>
                            :
                            <span className="logo-text">
                                <img src={logoMini} alt="homepage"/>
                            </span>
                        }
                    </Link>
                </div>
                <div className="scroll-sidebar">
                    <nav className="sidebar-nav">
                        <ul className="">
                            <li className="sidebar-item link-heading cursor-pointer">
                                <a onClick={this.toggleReportMenu} 
                                    data-tip data-for="report-info" 
                                    data-place="right" data-delay-show="300"
                                    className="sidebar-link"
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-file pr-1"></i>
                                            Reports
                                            <i className={`fa caret-icon ${
                                                isOpenReport ? 
                                                    'fa-caret-down' 
                                                    : 'fa-caret-right'}`
                                            }></i>
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-file mx-auto font-20 py-3"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="report-info">
                                    Reports
                                </ReactTooltip>
                                {isOpenReport && 
                                    <ul className="sub-menu">
                                        {auditFormAvailability && 
                                            <li className="sidebar-item" 
                                                onClick={() => this.openAuditFormModal()} 
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    Review Form
                                                </a>
                                            </li>
                                        }
                                        {agreementAvailability && 
                                            <li className="sidebar-item" 
                                                onClick={(e) => this.generatePDF(e, 2)}
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    Compensation <br/>Agreement
                                                </a>
                                            </li>
                                        }
                                        {jobDescriptionAvailability && 
                                            <li className="sidebar-item" 
                                                onClick={(e) => this.generatePDF(e, 3)}
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    Job Description
                                                </a>
                                            </li>
                                        }
                                        {KPIReportAvailability && 
                                            <li className="sidebar-item" 
                                                onClick={(e) => this.generatePDF(e, 4)}
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    KPI Explanations
                                                </a>
                                            </li>
                                        }

                                        {showperformacereport && <li className="sidebar-item" 
                                            onClick={this.openEvaluationModal}
                                        >
                                            <a href="javascript:" className="sidebar-link">
                                                Performance <br/>Evaluation Report
                                            </a>
                                        </li>
                                         }
                                        {commissionReportAvailability && 
                                            <li className="sidebar-item" 
                                                onClick={this.openCommissionModal}
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    {commissionName} Report
                                                </a>
                                            </li>
                                        }
                                        {timeClock && 
                                            <li className="sidebar-item" 
                                                onClick={this.openTimeSheetModal}
                                            >
                                                <a href="javascript:" className="sidebar-link">
                                                    Timesheet
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                }
                            </li>
                            <li className="sidebar-item link-heading cursor-pointer"
                                data-tip data-for="audit-info" 
                                data-place="right" data-delay-show="300"
                                onClick={this.closeAllMenu}
                            >
                                <a onClick={this.openArchivedAuditsModal} 
                                    className="sidebar-link" 
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-archive pr-1"></i>
                                            Saved Reviews
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-archive mx-auto font-20 py-3"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" 
                                    id="audit-info"
                                >
                                    Saved Reviews
                                </ReactTooltip>
                            </li>
                            {destinationsAvailability &&
                                <li className="sidebar-item link-heading cursor-pointer"
                                    data-tip data-for="destination-info" 
                                    data-place="right" data-delay-show="300"
                                    onClick={this.closeAllMenu}
                                >
                                    <a onClick={this.openDestinationModal} 
                                        className="sidebar-link" 
                                    >
                                        {fullSideBar ? 
                                            <React.Fragment>
                                                <i className="fa fa-map-marker pr-1"></i>
                                                Destinations
                                            </React.Fragment>
                                        :
                                            <i className="fa fa-map-marker mx-auto font-22 py-3"></i>
                                        }
                                    </a>
                                    <ReactTooltip className="react-tooltip-class" 
                                        id="destination-info"
                                    >
                                        Destinations
                                    </ReactTooltip>
                                </li>
                            }
                            
                            <li className="sidebar-item link-heading cursor-pointer" 
                                onClick={this.closeAllMenu}
                                data-tip data-for="kb-info" 
                                data-place="right" data-delay-show="300"
                            >
                                <a onClick={this.openTrainingVideosModal} 
                                    className="sidebar-link" 
                                >
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-question-circle pr-1"></i>
                                            Training Videos
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-question-circle mx-auto font-22 py-3"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="kb-info">
                                    Training Videos
                                </ReactTooltip>
                            </li>
                            {isAgencyMonitorVisble &&
                            <li className="sidebar-item link-heading cursor-pointer" 
                                onClick={this.closeAllMenu}
                                data-tip data-for="agency-monitor" 
                                data-place="right" data-delay-show="300"
                            >
                                <a onClick={this.openAgencyMonitor} href="/agency-monitor-staff" target="_blank" className="sidebar-link">
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-television"></i>
                                            Agency Monitor
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-television mx-auto font-20 py-3"></i>
                                    }
                                </a>
                                <ReactTooltip className="react-tooltip-class" id="agency-monitor">
                                    Agency Monitor
                                </ReactTooltip>
                            </li>
                            }
                            <li className="sidebar-item link-heading cursor-pointer"
                                data-tip data-for="support-info" 
                                data-place="right" data-delay-show="300"
                                onClick={this.closeAllMenu}
                            >
                                 
                                
                                <a onClick={this.openSupport} className="sidebar-link">
                                    {fullSideBar ? 
                                        <React.Fragment>
                                            <i className="fa fa-life-ring pr-1"></i>
                                            Support
                                        </React.Fragment>
                                    :
                                        <i className="fa fa-life-ring mx-auto font-20 py-3"></i>
                                    }
                                </a>

                                
                                <ReactTooltip className="react-tooltip-class" id="support-info">
                                    Support
                                </ReactTooltip>
                            </li>
                        </ul>
                    </nav>
                </div>
                
                {openSupportModal && 
                    <SupportModal modal={openSupportModal} 
                        toggleModal={this.toggleSupportModal} 
                    />
                }
                {openEvaluationModal && 
                    <EvaluationModal {...this.props} 
                        modal={openEvaluationModal} 
                        toggleModal={this.toggleEvaluationModal} 
                    />
                }
                {isOpenCommissionModal && 
                    <CommissionModal {...this.props} 
                        modal={isOpenCommissionModal} 
                        toggleModal={this.closeCommissionModal} 
                    />
                }
                {isOpenDestinations &&
                    <DestinationsModal modal={isOpenDestinations} 
                        toggleModal={this.toggleDestinationModal} 
                    />
                }
                {openAuditForm &&
                    <AuditForm {...this.props}
                        modal={openAuditForm} 
                        toggleModal={this.toggleAuditFormModal} 
                        auditId={auditId}
                        printAuditEmptyForm={(e) => this.generatePDF(e, 1, auditId)}
                        compensation={{
                            id: compId,
                            date_range: compDates
                        }}
                        permission={{
                            can_view: true,
                            can_add: true,
                            can_edit: true
                        }}
                        isStaff={true}
                    />
                }
                {openArchivedAudits &&
                    <ArchivedAudits {...this.props}
                        modal={openArchivedAudits} 
                        openAuditForm={this.openAuditFormModal}
                        toggleModal={this.toggleArchivedAuditsModal} 
                        printAuditEmptyForm={(e) => this.generatePDF(e, 1, auditId)}
                        isStaff={true}
                    />
                }
                {openTimeSheet &&
                    <PeriodSelectionModal {...this.props} 
                        modal={openTimeSheet} 
                        toggleModal={this.toggleTimeSheetModal} 
                        adminDashboard={false}
                        staffname={true}
                    />
                }
                {openTrainingVideos &&
                    <TrainingVideosModal {...this.props} 
                        modal={openTrainingVideos} 
                        toggleModal={this.toggleTrainingVideosModal} 
                    />
                }
            </aside>
        );
    };
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        agencyLocationList: state.LocationListReducer,
        authData: state.AuthReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            AgencyLocation: bindActionCreators(AuthAction, dispatch),
            StaffDashboard: bindActionCreators(StaffDashboardAction, dispatch),
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(SideNav);


// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/SideNav.js